// extracted by mini-css-extract-plugin
export default {"row":"summary-section_row__m9Jhi"};